import Image from 'global/Image';
import useSwitchAction from 'features/multi-porto/hooks/useSwitchAction';

import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';

import { Container, SelectButton } from './select.styled';

export default function TransferSelect({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: Readonly<BaseSecuritiesModalProps>) {
  const { onOpenTransferCash, onOpenTransferStock } = useSwitchAction();

  const handleOpenTransferCash = () => {
    onSubmit();
    onOpenTransferCash();
  };

  const handleOpenTransferStock = () => {
    onSubmit();
    onOpenTransferStock();
  };

  return (
    <BaseSecuritiesModal
      title="Select Asset"
      hideSubmit
      onCancel={onCancel}
      className="modal-multi-porto"
      transitionName=""
      {...props}
    >
      <Container onClick={(e) => e.stopPropagation()}>
        <SelectButton onClick={handleOpenTransferCash}>
          <div>
            <Image
              src="/icon/multi-porto/transfer-cash.svg"
              alt=""
              height={20}
              width={20}
            />
            <span>Transfer Cash</span>
          </div>
          <Image
            src="/icon/chevron-right-gray.svg"
            alt=""
            height={16}
            width={16}
          />
        </SelectButton>

        <SelectButton onClick={handleOpenTransferStock}>
          <div>
            <Image
              src="/icon/multi-porto/transfer-stock.svg"
              alt=""
              height={20}
              width={20}
            />
            <span>Transfer Stock</span>
          </div>
          <Image
            src="/icon/chevron-right-gray.svg"
            alt=""
            height={16}
            width={16}
          />
        </SelectButton>
      </Container>
    </BaseSecuritiesModal>
  );
}
